'use strict'

import React, {Component} from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import '../styles/App.css';
import firebase from './firebaseConnection';
import FileUploader from 'react-firebase-file-uploader';
import Popup from "reactjs-popup";


class Interviewers extends Component {

  constructor(props) {
    super(props);
    this.state = {
        Interviewers: [],
        id: '',
        company: '',
        Hours: null,
        hour: '',
        modal: false,
        nestedModal: false,
        lastModal: false,
        closeAll: false,
        resumeUrl: '',
        resumeName: '',
        email: '',
        name: '',
        available: '',
        hourId: ''
    };

    this.toggleNested = this.toggleNested.bind(this);
    this.toggleAll = this.toggleAll.bind(this);
    this.toggle = this.toggle.bind(this);
    this.handleInterviews = this.handleInterviews.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  /**************************CALLING FIREBASE*************************************/

  componentDidMount() {
      firebase.database().ref('Interviews/').once('value').then(snapshot => {
        this.setState({Interviewers: snapshot.val() })
      })
  };

  /*******************************************************************************/
  handleInterviewers(item) {
    return (
      <div className="homeExhibitors">
        <img className="homeExhibitors" key={item.Name} src={item.Logo}/>
        <a className="homeExhibitors" onClick={this.toggle.bind(this, item)}>Citas {item.Name} aquí</a>
      </div>
    )
  }

  toggle(item) {
    if (item !== undefined) {
      this.setState({
        company: item.Name,
        Hours: item.Hours,
        modal: !this.state.modal
      })
      if (item.Name === "Avantica") {
        this.setState({id: 0})
      } else if (item.Name === "GoLabs") {
        this.setState({id: 1})
      } else if (item.Name === "Ubitec") {
        this.setState({id: 2})
      }
    }
    else {
      this.setState({
        modal: !this.state.modal
      })
    }
  }


 toggleNested(item) {
   if (item !== undefined) {
    this.setState({
      hour: item.Hour,
      available: item.Available,
      hourId: item.Id,
      nestedModal: !this.state.nestedModal,
      closeAll: false
    });
  } else {
      this.setState({
        nestedModal: !this.state.nestedModal,
        closeAll: false
      })
    }
  }

  toggleAll() {
    this.setState({
      nestedModal: !this.state.nestedModal,
      lastModal: false,
      closeAll: true,
      resumeUrl: '',
      email: '',
      name: '',
      resumeName: ''
    });
  }

  gettingHours(item) {
    if (item.Available > 0) {
      return <h1 className="hours" value={item.Hour} key={item.Hour} onClick={this.toggleNested.bind(this, item)}>{item.Hour}</h1>
    } else {
      return false
    }
  }

  /****************************UPLOADING RESUME********************************/
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleInterviews() {
    var prueba = this.state.hourId;
    var available = this.state.available - 1, id = this.state.id, key = this.state.email.replace('.',''),
    interviewsList =  firebase.database.Reference =  firebase.database().ref('Interviews/' + id + '/Interviews'),
    interviews = interviewsList.child(key);
    var setAvailables =  firebase.database.Reference =  firebase.database().ref('Interviews/' + id + '/Hours/' + prueba + '/Available');
    setAvailables.set(available)
    this.setState({available: available})
    interviews.set({
      Name: this.state.name,
      Email: this.state.email,
      Hour: this.state.hour,
      Resume: this.state.resumeUrl
    })
    this.setState({
      lastModal: !this.state.lastModal,
    });
  }

  handleUploadSuccess = (filename) => {
     this.setState({resumeName: filename});
     firebase.storage().ref('UsersResume').child(filename).getDownloadURL().then(url => this.setState({resumeUrl: url}));
   };

  /****************************RENDER*******************************/
  render() {
    var Interviewers = this.state.Interviewers.map(this.handleInterviewers.bind(this));
    var Hours, Send;
    if (this.state.name !== '' && this.state.hours !== '' && this.state.resumeUrl !== '') {
      Send = <Button color="primary" onClick={this.handleInterviews}>Enviar</Button>
    } else {
      Send = <Button color="primary" onClick={this.handleInterviews} disabled>Enviar</Button>
    }
    if (this.state.Hours !== [] && this.state.Hours !== undefined && this.state.Hours !== null) {
      Hours = this.state.Hours.map(this.gettingHours.bind(this));
    }

    return (
      <div className="interviewsDiv">
        {Interviewers}
        <Modal isOpen={this.state.modal} toggle={this.toggle}>
         <ModalHeader toggle={this.toggle}>Citas de entrevista para {this.state.company}</ModalHeader>
         <ModalBody>
          {Hours}
          <br/>
          *Por favor selecione una hora para agendar su entrevista, si no aparecen horas en este apartado es porque la empresa seleccionada
          ya no cuenta con espacios disponibles.
           <br/>
           <Modal isOpen={this.state.nestedModal} toggle={this.toggleNested} onClosed={this.state.closeAll ? this.toggle : undefined}>
            <ModalHeader>
              Hora seleccionada: {this.state.hour}
            </ModalHeader>
             <ModalBody>
              *Complete el formulario para finalizar la reservación de su cita de entrevista.
              <br/><br/>
               <h1 className="formInterviews">Nombre completo:</h1>
               <input className="formInterviews" name="name" onChange={this.handleChange} required></input>
               <h1 className="formInterviews">Correo electrónico:</h1>
               <input className="formInterviews" name="email" onChange={this.handleChange} required></input>
               <h1 className="formInterviews">Curriculum:</h1>
               <label style={{backgroundColor: 'steelblue', color: 'white', padding: 10, borderRadius: 4, pointer: 'cursor'}}>
                 {this.state.resumeName == '' ? 'Seleccionar curriculum' : this.state.resumeName}
                 <FileUploader
                   hidden
                   accept="application/pdf"
                   storageRef={firebase.storage().ref('UsersResume')}
                   onUploadSuccess={this.handleUploadSuccess}
                 />
               </label>
             </ModalBody>
             <Modal isOpen={this.state.lastModal} toggle={this.state.lastModal}>
               <ModalHeader>¡Listo!</ModalHeader>
               <ModalBody>
                {this.state.name} su cita será el 27 de Julio a las {this.state.hour}, por favor presentarse 10 minutos antes.
               </ModalBody>
               <ModalFooter>
                 <Button color="secondary" onClick={this.toggleAll}>Entendido</Button>
               </ModalFooter>
             </Modal>
             <ModalFooter>
               {Send}{' '}
               <Button color="secondary" onClick={this.toggleAll}>Cancelar</Button>
             </ModalFooter>
           </Modal>
         </ModalBody>
         <ModalFooter>
           <Button color="secondary" onClick={this.toggle}>Cancelar</Button>
         </ModalFooter>
       </Modal>
      </div>
    );
  };
}

export default Interviewers;



// WEBPACK FOOTER //
// ./src/app/getInterviewers.js